"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EssentialPurposeSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.EssentialPurposeSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback sub purpose */
    Essential: 'ESSENTIAL',
});
//# sourceMappingURL=essential.js.map